import React from 'react';
import PropTypes from 'prop-types';
import Element from './Element';

class Input extends React.Component {
  render() {
    const { elementClass, label, unit, errorClass, ...inputProps } = this.props;
    return (
    <Element elementClass={elementClass} label={label} unit={unit}>
       <div className="Question-Container" style={{'margin': '8px'}}>
          <input className={`Input-Text ${errorClass !== '' ? errorClass : ''}`} {...inputProps} maxLength="50" />
        </div>
    </Element>)
  }
};

Input.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  elementClass: PropTypes.string,
  onChange: PropTypes.func,
}

export default Input;
